import { useState } from "react";

// Re-checks the case just before a dialog's confirm runs, as someone else on the
// case may have acted since the page loaded. `problem` is the message to show
// when they have, or `true` when the check itself failed.
const useRecheck = () => {
  const [checking, setChecking] = useState(false);
  const [problem, setProblem] = useState<string | boolean>(false);

  const recheck = async (
    isStillValid: () => Promise<boolean>,
    staleMessage: string,
  ) => {
    setChecking(true);
    setProblem(false);
    try {
      if (await isStillValid()) return true;
      setProblem(staleMessage);
    } catch {
      setProblem(true);
    } finally {
      setChecking(false);
    }
    return false;
  };

  return {
    checking,
    problem,
    // A stale action can't succeed on retry; a failed check can.
    isStale: typeof problem === "string",
    recheck,
    reset: () => setProblem(false),
  };
};

export default useRecheck;
